import type { ButtonProps } from 'antd'
import { Button, Tooltip } from 'antd'
import { usePrefillBlockedReason } from 'features/libra/stepComponents/prefillGate'
import type { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import cantileverTheme from 'styles/cantileverTheme'

const AiAutofillButton = styled(Button)<{ $plain?: boolean }>`
  ${({ $plain }) =>
    !$plain &&
    css`
      background-color: ${cantileverTheme.colors.OceanBlue} !important;
    `}
`

const ButtonWrapper = styled.span<{ $block?: boolean }>`
  display: ${({ $block }) => ($block ? 'flex' : 'inline-flex')};
`

export interface AiPrefillButtonProps extends ButtonProps {
  /** Shown when the button is not blocked by unsaved changes. */
  tooltip?: ReactNode
  /** Drops the AI accent colour for a neutral button. */
  plain?: boolean
}

/**
 * The AI pre-fill action. It owns the save-before-prefill gate, so callers pass
 * only their own disabled reasons and tooltip.
 */
export const AiPrefillButton: FC<AiPrefillButtonProps> = ({
  tooltip,
  plain,
  block,
  disabled,
  ...buttonProps
}) => {
  const blockedReason = usePrefillBlockedReason()

  return (
    <Tooltip title={blockedReason ?? tooltip}>
      <ButtonWrapper $block={block}>
        <AiAutofillButton
          {...buttonProps}
          block={block}
          $plain={plain}
          disabled={disabled || blockedReason !== null}
        />
      </ButtonWrapper>
    </Tooltip>
  )
}
